var _a;
import { TimeRange } from "sbtech-sports-data-api-client";
export var addHours = function (from, hoursToAdd) {
    return new Date(from.getFullYear(), from.getMonth(), from.getDate(), from.getHours() + hoursToAdd, from.getMinutes(), from.getSeconds());
};
export var addDays = function (from, daysToAdd) {
    return new Date(from.getFullYear(), from.getMonth(), from.getDate() + daysToAdd, from.getHours(), from.getMinutes(), from.getSeconds());
};
export var DateRangeMapper = (_a = {},
    _a[TimeRange.OneHour] = function (from) { return addHours(from, 1); },
    _a[TimeRange.TwoHours] = function (from) { return addHours(from, 2); },
    _a[TimeRange.ThreeHours] = function (from) { return addHours(from, 3); },
    _a[TimeRange.SixHours] = function (from) { return addHours(from, 6); },
    _a[TimeRange.TwelveHours] = function (from) { return addHours(from, 12); },
    _a[TimeRange.OneDay] = function (from) { return addDays(from, 1); },
    _a[TimeRange.TwoDays] = function (from) { return addDays(from, 2); },
    _a[TimeRange.ThreeDays] = function (from) { return addDays(from, 3); },
    _a[TimeRange.SevenDays] = function (from) { return addDays(from, 7); },
    _a);
//# sourceMappingURL=DateRangeMapper.js.map